import { useCnbConfig } from "@core/hooks/useCnbConfig";

export default function HelpDesk() {
  const { data } = useCnbConfig() ?? {};
  const { helpdesk } = data ?? {};

  return helpdesk?.isActive ? (
    <div className="header-xl:px-[40px] header-xl:py-[30px] xl absolute top-[103px] right-[30px] bg-gray-100 p-[20px]">
      <p className="text-[24px] font-bold text-gray-700">{helpdesk?.phone}</p>
      {helpdesk?.content && <div className="text-md mt-[14px] text-gray-500" dangerouslySetInnerHTML={{ __html: helpdesk?.content }}></div>}
    </div>
  ) : (
    <></>
  );
}
